class FeaturedProductsTabs extends HTMLElement {
  connectedCallback() {
    this.tabButtons = this.querySelectorAll('.featured-products__tab-button');
    this.tabContents = this.querySelectorAll('.featured-products__tab-content');

    if (!this.tabButtons.length) return;

    this.tabButtons.forEach(button => {
      button.addEventListener('click', this.onTabClick.bind(this));
    });
  }

  onTabClick(event) {
    event.preventDefault();
    const clickedButton = event.currentTarget;
    const targetTab = clickedButton.getAttribute('data-tab');

    // Update button states
    this.tabButtons.forEach(button => {
      button.setAttribute('aria-current', 'false');
      button.classList.remove('featured-products__tab-button--active');
    });
    clickedButton.setAttribute('aria-current', 'true');
    clickedButton.classList.add('featured-products__tab-button--active');

    // Update content visibility
    this.tabContents.forEach(content => {
      const isActive = content.getAttribute('data-tab-content') === targetTab;

      content.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      content.classList.toggle('featured-products__tab-content--active', isActive);

      if (isActive) {
        // Wait one frame for display:flex to apply, then fix Swiper dimensions
        requestAnimationFrame(() => {
          const swiperEl = content.querySelector('.swiper');
          if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.update();
          }
        });
      }
    });
  }
}

if (!customElements.get('featured-products-tabs')) {
  customElements.define('featured-products-tabs', FeaturedProductsTabs);
}